import { useEffect } from "react";

// Gestion du <head> par page, sans dépendance (title, description, canonical, OG/Twitter, JSON-LD).
const BASE = "https://energymarket.fr";

function upsertMeta(attr, key, content) {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(url) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

function upsertJsonLd(id, data) {
  let el = document.getElementById(id);
  if (!data) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export default function Seo({ title, description, path = "", image = "/img/hero-b3c.png", jsonLd }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | Energy Market` : "Energy Market — Courtier énergétique";
    const url = BASE + path;
    document.title = fullTitle;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title ? `${title} | Energy Market` : "Energy Market — Courtier énergétique");
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:url", url);
    upsertMeta("property", "og:image", image.startsWith("http") ? image : BASE + image);
    upsertMeta("name", "twitter:title", fullTitle);
    upsertMeta("name", "twitter:description", description);
    upsertCanonical(url);
    upsertJsonLd("ld-page", jsonLd || null);
    return () => upsertJsonLd("ld-page", null);
  }, [title, description, path, image, jsonLd]);

  return null;
}
